import { StyleSheet, Text, View } from "react-native";
import { useTranslation } from "react-i18next";
import { SET_PAUSE_PHASES } from "@heraion/shared";

import { pausePhaseMeaning, pausePhaseName } from "./pauseWords";
import type { UiTheme } from "./theme";

// HI-8: the three phases of a rep, each with its plain meaning. One component
// for the exercise sheet and the editor's «?» (§10.6: the explanation is found
// again, not only in a tip seen once). The host draws the frame around it.
export function PauseExplainer({ theme }: { theme: UiTheme }) {
  const { t } = useTranslation();
  const styles = makeStyles(theme);
  return (
    <View style={styles.list}>
      {SET_PAUSE_PHASES.map((phase) => (
        // One stop per phase for a screen reader: name, then meaning.
        <View key={phase} accessible style={styles.item}>
          <Text style={styles.name}>{pausePhaseName(t, phase)}</Text>
          <Text style={styles.meaning}>{pausePhaseMeaning(t, phase)}</Text>
        </View>
      ))}
    </View>
  );
}

function makeStyles(theme: UiTheme) {
  const { palette: p, spacing: s, typography: ty } = theme;
  return StyleSheet.create({
    list: { gap: s.s3 },
    item: { gap: s.s1 },
    name: { color: p.ink, fontSize: ty.sizes.sm, fontWeight: "700" },
    meaning: { color: p.ink2, fontSize: ty.sizes.sm, lineHeight: ty.sizes.sm * 1.4 },
  });
}
